var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content g9" },
    [
      _c(
        "Accord",
        { attrs: { title: "Materials" } },
        [
          _c(
            "Accord",
            { attrs: { title: "Supply amounts" } },
            [
              _c(
                "Tabs",
                { attrs: { menu: ["Total DUN", "Total Primary Packaging"] } },
                [
                  _c(
                    "div",
                    { staticClass: "tab" },
                    [
                      _c("LineChart", {
                        attrs: {
                          "chart-name": "aggregationSupplyTotalDun",
                          settings: _vm.supplyTotalDunSettings,
                          isAggregation: true,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tab" },
                    [
                      _c("LineChart", {
                        attrs: {
                          "chart-name": "aggregationSupplyPackaging",
                          settings: _vm.supplyPackagingSettings,
                          isAggregation: true,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Accord",
            { attrs: { title: "Ancillary amount" } },
            [
              _c("LineChart", {
                attrs: {
                  "chart-name": "aggregationAncillaryAmount",
                  settings: _vm.ancillaryAmountSettings,
                  isAggregation: true,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Accord",
            { attrs: { title: "Packaging Campaigns" } },
            [
              _c("LineChart", {
                attrs: {
                  "chart-name": "aggregationPackagingCampaigns",
                  settings: _vm.packagingCampaignsSettings,
                  isAggregation: true,
                  "is-gantt": true,
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "right",
                  on: { click: _vm.onDownloadProductionPlanClick },
                },
                [_vm._v("Download packaging plan")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Accord",
            { attrs: { title: "Stock Level" } },
            [
              _c("Tabs", { attrs: { menu: ["Site", "Depot"] } }, [
                _c(
                  "div",
                  { staticClass: "tab" },
                  [
                    _c("LineChart", {
                      attrs: {
                        "chart-name": "aggregationStockSite",
                        settings: _vm.stockSettings,
                        isAggregation: true,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tab" },
                  [
                    _c("LineChart", {
                      attrs: {
                        "chart-name": "aggregationStockDepot",
                        settings: _vm.stockSettings,
                        isAggregation: true,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Accord",
            { attrs: { title: "Cost" } },
            [
              _c("Tabs", { attrs: { menu: ["DUN", "API", "Ancillary"] } }, [
                _c(
                  "div",
                  { staticClass: "tab" },
                  [
                    _c("LineChart", {
                      attrs: {
                        "chart-name": "aggregationCostDun",
                        settings: _vm.costSettings,
                        isAggregation: true,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tab" },
                  [
                    _c("LineChart", {
                      attrs: {
                        "chart-name": "aggregationCostApi",
                        settings: _vm.costSettings,
                        isAggregation: true,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tab" },
                  [
                    _c("LineChart", {
                      attrs: {
                        "chart-name": "aggregationCostAncillary",
                        settings: _vm.costSettings,
                        isAggregation: true,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }